var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29148 16.583C12.8707 16.583 16.583 12.8707 16.583 8.29148C16.583 3.71222 12.8707 0 8.29148 0C3.71222 0 0 3.71222 0 8.29148C0 12.8707 3.71222 16.583 8.29148 16.583Z",
    fill: "#BAE1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5614 6.21899H6.02151C4.87689 6.21899 3.94897 7.14689 3.94897 8.29152C3.94897 9.43614 4.87689 10.364 6.02151 10.364H10.5614C11.706 10.364 12.6339 9.43614 12.6339 8.29152C12.6339 7.14689 11.706 6.21899 10.5614 6.21899Z",
    fill: "#5BB8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07169 8.90727C6.41184 8.90727 6.68759 8.63155 6.68759 8.29141C6.68759 7.95126 6.41184 7.67554 6.07169 7.67554C5.73155 7.67554 5.45581 7.95126 5.45581 8.29141C5.45581 8.63155 5.73155 8.90727 6.07169 8.90727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29142 8.90727C8.63157 8.90727 8.90732 8.63155 8.90732 8.29141C8.90732 7.95126 8.63157 7.67554 8.29142 7.67554C7.95127 7.67554 7.67554 7.95126 7.67554 8.29141C7.67554 8.63155 7.95127 8.90727 8.29142 8.90727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5114 8.90727C10.8516 8.90727 11.1273 8.63155 11.1273 8.29141C11.1273 7.95126 10.8516 7.67554 10.5114 7.67554C10.1713 7.67554 9.89551 7.95126 9.89551 8.29141C9.89551 8.63155 10.1713 8.90727 10.5114 8.90727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.583,
    height: 16.583,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6fbeb7a77159e07bdf256690cac2dbc7.svg";
export { ForwardRef as ReactComponent };